<template>
  <div class="row">
    <div class="col-lg-8 m-auto">
      <form @submit.prevent="reset" @keydown="form.onKeydown($event)">
        <card head foot :title="$t('login.reset_password')">
          <alert type="success" dismissable v-if="status">
            <span>{{ status }}</span>
          </alert>
          <!-- Email -->
          <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('login.email') }}</label>
            <div class="col-md-7">
              <input v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }" class="form-control"
                type="email" name="email" readonly>
              <has-error :form="form" field="email" />
            </div>
          </div>
          <!-- Password -->
          <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('login.password') }}</label>
            <div class="col-md-7">
              <input v-model="form.password" :class="{ 'is-invalid': form.errors.has('password') }" class="form-control"
                type="password" name="password">
              <has-error :form="form" field="password" />
            </div>
          </div>
          <!-- Password Confirmation -->
          <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('login.confirm_password') }}</label>
            <div class="col-md-7">
              <input v-model="form.password_confirmation"
                :class="{ 'is-invalid': form.errors.has('password_confirmation') }" class="form-control" type="password"
                name="password_confirmation">
              <has-error :form="form" field="password_confirmation" />
            </div>
          </div>
          <!-- Submit Button -->
          <footer slot="footer" class="card-footer">
            <div class="form-group row mb-0">
              <div class="col-md-9 ms-md-auto">
                <button class="btn btn-primary" type="submit" :class="[{ 'btn-loading': form.busy }]">
                  {{ $t('login.reset_password') }}
                </button>
              </div>
            </div>
          </footer>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import Form from 'vform'

export default {
  middleware: 'guest',

  metaInfo() {
    return { title: this.$t('login.reset_password') }
  },

  data: () => ({
    status: '',
    form: new Form({
      token: '',
      email: '',
      password: '',
      password_confirmation: ''
    })
  }),

  created() {
    this.form.email = this.$route.query.email
    this.form.token = this.$route.params.token
  },

  methods: {
    async reset() {
      const { data } = await this.form.post('/password/reset')

      this.status = data.status

      this.form.reset()
    }
  }
}

</script>
